import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import moment from "moment";
import { useParams } from "react-router-dom";
import { axiosInstance } from "../../redux/constants/axiosInstance";
import { API_URL } from "../../redux/constants/type";
import Loader from "../../components/Dailogs/Loader";
import "./../../assets/styles/local/QuotePdf.css";
import { formattedCurrency } from "../../utils/helpers/calculateTime";
import QuotePdfDocument from "../../utils/helpers/quote.pdf.document";
import { useHistory } from "react-router-dom";
import printJS from "print-js";
import { usePDF } from "@react-pdf/renderer";

const QuotePdf = () => {
  const { quoteid } = useParams();
  const history = useHistory();
  const [quote, setQuote] = useState(null);
  const [pdfInstance, setPdfInstance] = usePDF({});
  const [isPrinting, setIsPrinting] = useState(false);

  const handleNewData = (data) => {
    let list = [];
    let quote = { ...data };
    data?.sections?.map((section) => {
      section?.subSections?.map((subSection) => {
        let { title, total, subSectionParts, description } = subSection;
        let section = {
          sectionName: title,
          totalAmount: total,
          description: description,
          subSections: subSectionParts?.map((item) => ({
            ...item,
            isApproved: false,
            description: description,
            subsectionid: item?.subsectionPartid,
          })),
        };
        list.push(section);
      });
    });
    quote["sections"] = list;
    setQuote(quote);
  };

  useEffect(() => {
    axiosInstance
      .get(`${API_URL}/api/quote/${quoteid}/pdf`)
      .then((res) => {
        let updatedData = updateQuoteData(res.data.data);
        handleNewData(updatedData);
      })
      .catch((err) => console.log(err));
  }, [quoteid]);

  const updateQuoteData = (data) => {
    data.total = 0;
    data.sections.forEach((section) => {
      section.subSections.forEach((subsection) => {
        subsection.isApproved = false;
      });
      data.total += section.totalAmount;
    });
    return data;
  };

  const handleSubsectionStatusChange = (item, status) => {
    let oldData = { ...quote };
    oldData.sections.forEach((section) => {
      if (section.sectionid === item.sectionid) {
        section.subSections.forEach((subsection) => {
          if (subsection.subsectionid === item.subsectionid) {
            subsection.isApproved = status;
          }
        });
      }
    });
    setQuote(oldData);
  };

  const handlePrintPdf = () => {
    const myPdfDocument = <QuotePdfDocument quote={quote} />;
    setPdfInstance(myPdfDocument);
    setIsPrinting(true);
  };

  useEffect(() => {
    if (isPrinting && pdfInstance.url && !pdfInstance.loading) {
      printJS(pdfInstance.url);
      setIsPrinting(false);
    }
  }, [isPrinting, pdfInstance.url, pdfInstance.loading]);

  const RenderSubSection = ({ item }) => {
    return (
      <>
        <div className="sub-section-container">
          <div>
            <div className="sub-section-part-code">{item.productPartCode}</div>
            <div className="sub-section-part-name">{item.productPartName}</div>
          </div>
          <div className="sub-section-qty text-center">{item.qty}</div>
          <div className="sub-section-total bg-sub-section-total">
            {formattedCurrency(item.total)}
          </div>
          <div className="text-center">
            <input
              type="checkbox"
              className="section-status-checkbox"
              id={`sub-section-approved-${item.subsectionid}`}
              checked={item.isApproved}
              onChange={(e) =>
                handleSubsectionStatusChange(item, e.target.checked)
              }
            />
            <label
              htmlFor={`sub-section-approved-${item.subsectionid}`}
            ></label>
          </div>
        </div>
      </>
    );
  };

  const RenderSection = ({ item }) => {
    return (
      <div className="section-container">
        <div className="section-header">
          <div className="section-header-name">{item.sectionName}</div>
          <div className="section-header-status text-center">Status</div>
        </div>
        <div className="section-details">
          <div className="sub-section-container header">
            <div className="header-light-text">Material</div>
            <div className="header-light-text text-center">Qty</div>
            <div className="sub-section-total">Total</div>
            <div className="header-dark-text text-center">Approve</div>
          </div>
          {item.subSections.map((subsection, index) => (
            <RenderSubSection key={`sub-section-${index}`} item={subsection} />
          ))}

          {item.description && (
            <div
              className="sub-section-part-code px-5 text-truncat-e"
              // style={{ maxWidth: "670px" }}
              dangerouslySetInnerHTML={{ __html: item.description }}
            />
          )}

          <div className="sub-section-container footer">
            <div className="sub-section-footer-total">Total Section</div>
            <div className="header-light-text text-center"></div>
            <div className="sub-section-total sub-section-footer-total">
              {formattedCurrency(item.totalAmount)}
            </div>
            <div className="header-dark-text text-center"></div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Header />
      {!quote && <Loader />}
      {quote && (
        <div className="container py-3">
          <div className="d-flex justify-content-end mb-3">
            <div className="quote-code-container">
              <div className="fw-bold">Quote</div>
              <div>
                <div className="fw-bold">ID &nbsp;&nbsp;{quote.quoteCode}</div>
                <span className="text-muted">
                  {moment(quote.updatedDate).format("DD.MM.YYYY")}
                </span>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column">
            {quote.sections.map((section, index) => (
              <RenderSection key={`section-${index}`} item={section} />
            ))}
            <div className="section-container mt-3">
              <div className="section-details py-4">
                <div className="sub-section-container footer">
                  <div className="sub-section-footer-total">Total Quote</div>
                  <div className="header-light-text text-center"></div>
                  <div className="sub-section-total sub-section-footer-total">
                    {formattedCurrency(quote.total)}
                  </div>
                  <div className="header-dark-text text-center"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end mt-3 gap-3">
            <button
              className="cal-page-cancel"
              onClick={() => {
                history.goBack();
              }}
            >
              Cancel
            </button>
            <button
              className="cal-page-cancel cal-page-print"
              onClick={handlePrintPdf}
              disabled={isPrinting || pdfInstance?.loading}
            >
              {isPrinting ? "Loading..." : "Print"}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default QuotePdf;
